/* eslint-disable no-tabs */
/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { Box, Flex, Img, Text } from '@chakra-ui/react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { appApi } from '../../../services/appApi'
const Calendario = 'https://sigah.blob.core.windows.net/assets/front/calendarWeek.svg'
const UserPlus = 'https://sigah.blob.core.windows.net/assets/front/userPlus.svg'
const Engrenagem = 'https://sigah.blob.core.windows.net/assets/front/engrenagens.svg'
const Clipboard = 'https://sigah.blob.core.windows.net/assets/front/clipboardCheck.svg'
const Entrada = 'https://sigah.blob.core.windows.net/assets/front/entrada.svg'

interface iSection{
  texto: string
  ativo: boolean
  jaPreenchido: boolean
  path?: string
  icone: any
}

interface iProps {
  id: string
}

export const TimelineFeedback: React.FC<iProps> = ({ id }) => {
  const { pathname } = useLocation()
  const nav = useNavigate()
  const [StatusFeedback, setStatusFeedback] = useState<number>(0)

  function GetStatus(): void {
    if (id === '') return

    appApi.get(`FeedbackPersonalizado/${id}/Status`)
      .then(res => setStatusFeedback(res.data))
      .catch(err => console.log(err))
  }

  function GetSections(): iSection[] {
    const sections: iSection[] = []
    let jaPreenchido = true

    sections.push({
      ativo: pathname.includes('Criar'),
      jaPreenchido: jaPreenchido,
      texto: 'Criando Feedback',
      icone: Engrenagem
    })
    if (pathname.includes('Criar')) {
      jaPreenchido = false
    }

    sections.push({
      ativo: pathname.includes('Entrada'),
      jaPreenchido: jaPreenchido || StatusFeedback > 0,
      texto: 'Informações prévias',
      icone: Entrada,
      path: `/Feedback/${id}/Entrada`
    })
    if (pathname.includes('Entrada')) {
      jaPreenchido = false
    }

    sections.push({
      ativo: pathname.includes('Desenvolvimento'),
      jaPreenchido: jaPreenchido || StatusFeedback > 0,
      texto: 'Itens para condução​',
      icone: Clipboard,
      path: `/Feedback/${id}/Desenvolvimento`
    })
    if (pathname.includes('Desenvolvimento')) {
      jaPreenchido = false
    }

    sections.push({
      ativo: pathname.includes('Participantes'),
      jaPreenchido: jaPreenchido || StatusFeedback > 1,
      texto: 'Participantes',
      icone: UserPlus,
      path: `/Feedback/${id}/Participantes`
    })
    if (pathname.includes('Participantes')) {
      jaPreenchido = false
    }

    sections.push({
      ativo: pathname.includes('Envio'),
      jaPreenchido: jaPreenchido || StatusFeedback > 2,
      texto: 'Gestão de envios',
      icone: Calendario,
      path: `/Feedback/${id}/Envio`
    })

    return sections
  }

  function GetColor(e: iSection, nextItem?: iSection): string {
    if (nextItem?.jaPreenchido) {
      return 'var(--Azul)'
    }
    return e.ativo ? 'var(--Green2)' : e.jaPreenchido ? 'var(--Azul)' : 'var(--c6)'
  }

  useEffect(() => {
    GetStatus()
  }, [])

  return (
		<Flex alignItems={'center'} mb={'3rem'} mx={'auto'}>
			{GetSections().map((e, i) => {
			  return (<>
					<Flex onClick={() => { if (e.path && e.jaPreenchido) { nav(e.path) } }} flexDirection={'column'} w={'66px'} position={'relative'} alignItems={'center'} justifyContent={'center'}>
						<Box w={'72px'} h={'72px'} display={'flex'} alignItems={'center'} justifyContent={'center'} borderRadius={'50%'} bgColor={GetColor(e)} border={`2px solid ${GetColor(e)}`} _hover={(e.path && !e.ativo && e.jaPreenchido) ? { cursor: 'pointer', bg: 'var(--Rosa)', borderColor: 'var(--Rosa)' } : {}}>
							<Img src={e.icone} w={'38px'} h={'38px'}/>
						</Box>
						<Text _hover={(e.path && !e.ativo && e.jaPreenchido) ? { cursor: 'pointer', color: 'var(--Azul)', textDecoration: 'underline' } : {}} minWidth={'120px'} position={'absolute'} fontWeight={600} fontSize={'.875rem'} lineHeight={'1rem'} top={'82px'} textAlign={'center'}>{e.texto}</Text>
					</Flex>
					{i !== (GetSections().length - 1) && <Box bgColor={GetColor(e, GetSections()[i + 1])} height={'5px'} w={'198px'}></Box>}
				</>)
			})}
		</Flex>
  )
}
